import React, { useState, useRef, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiSend } from "react-icons/fi";
import { BsCalendarCheck } from "react-icons/bs";
import MyNavbar from "../../../../../components/user/general/mynavbar/MyNavbar.js";
import Footer from "../../../../../components/user/general/footer/Footer.js";
import EquipmentBookingModal from "../../../../../subscreens/users/shop/bookingform/BookingForm.js";
import "../../../../../assets/css/user/shoppage/productdetailpage/equipmentchat/EquipmentChat.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../../../context/AppContext.js";

const EquipmentChat = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);

  const equipment = state?.equipment;
  // const shop = state?.shop;

  const [newMessage, setNewMessage] = useState("");
  const [sendLoading, setSendLoading] = useState(false);
  const [messages, setMessages] = useState([]);

  const [showBookingModal, setShowBookingModal] = useState(false);

  const messagesEndRef = useRef(null);

  if (!equipment) {
    navigate(-1);
    return null;
  }

  // ── handleSendFirstMessage ─────────────────────────────────────
  const handleSendFirstMessage = () => {
    if (!newMessage.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Message Required",
        text: "Please type a message first",
      });
      return;
    }

    const savedCustomer = JSON.parse(localStorage.getItem("LoggedInCustomer"));
    const token = localStorage.getItem("authToken");

    if (!savedCustomer || !savedCustomer.id) {
      Swal.fire({
        icon: "warning",
        title: "Login Required",
        text: "Please login first",
      });
      navigate("/auth");
      return;
    }

    setSendLoading(true);

    // Step 1: Conversation banao
    const formData = new FormData();
    formData.append("srcustomer_id", savedCustomer.id);
    formData.append("srrentaladmin_id", equipment.srrentaladmin_id);
    formData.append("type", "general");
    formData.append("lastmessage", newMessage);

    axios
      .post(`${baseUrl}/customer/conversations/createConversation`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`, // 👈 ye line add ki
        },
      })
      .then((res) => {
        console.log("Create Conversation Response:");
        console.log(res.data);
        if (res.data.success === true) {
          const conversationId = res.data.conversation.id;

          // Step 2: Message bhejo
          const msgFormData = new FormData();
          msgFormData.append("srconversation_id", conversationId);
          msgFormData.append("sender", "user");
          msgFormData.append("message", newMessage);

          return axios
            .post(`${baseUrl}/customer/chat/sendMessage`, msgFormData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            })
            .then((msgRes) => {
              if (msgRes.data.success === true) {
                setSendLoading(false);
                setNewMessage("");
                navigate("/user/messages", {
                  state: { openConversationId: conversationId },
                });
              }
            });
        } else {
          throw new Error(res.data.message);
        }
      })
      .catch((err) => {
        setSendLoading(false);
        console.log("Error:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to send message",
        });
      });
  };

  return (
    <>
      <MyNavbar />

      <div className="equipment-chat-page">
        <div className="equipment-chat-wrapper">
          {/* LEFT IMAGE */}
          <div className="equipment-chat-image-section">
            <img
              src={`${baseUrlForFile}/${equipment.image}`}
              alt={equipment.equipmentname}
              className="equipment-chat-image"
            />
            <span className="equipment-status available">AVAILABLE</span>
          </div>

          {/* RIGHT CHAT */}
          <div className="equipment-chat-area">
            {/* HEADER */}
            <div className="equipment-chat-header">
              <h2>
                {equipment.name}
                <span className="equipment-rate">
                  {equipment.rates && equipment.rates.length > 0
                    ? equipment.rates.map((r, i) => (
                        <span key={i} style={{ marginRight: "8px" }}>
                          Rs. {r.value.toLocaleString("en-PK")} / {r.unit}
                        </span>
                      ))
                    : "Price on request"}
                </span>
              </h2>
            </div>

            {/* MESSAGES AREA */}
            <div className="equipment-messages-area">
              <p className="equipment-empty-text">
                Send your first message to start conversation with{" "}
                <strong>{equipment.shopName}</strong>
              </p>
              <div ref={messagesEndRef} />
            </div>

            {/* INPUT */}
            <div className="equipment-input-area">
              <input
                type="text"
                placeholder="Type your message..."
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleSendFirstMessage();
                  }
                }}
                disabled={sendLoading}
              />
              <button onClick={handleSendFirstMessage} disabled={sendLoading}>
                {sendLoading ? "..." : <FiSend />}
              </button>
            </div>

            {/* BOOK BUTTON */}
            <button
              className="equipment-book-btn"
              onClick={() => setShowBookingModal(true)}
            >
              <BsCalendarCheck />
              BOOKING NOW
            </button>

            <p className="equipment-footer-text">
              PROFESSIONAL AGRICULTURAL EQUIPMENT RENTAL
            </p>
          </div>
        </div>
      </div>

      <Footer />

      <EquipmentBookingModal
        show={showBookingModal}
        onHide={() => setShowBookingModal(false)}
        equipmentData={{ equipment, owner: equipment?.name || "Owner Name" }}
      />
    </>
  );
};

export default EquipmentChat;
